module.exports = __webpack_public_path__ + "img/luoyangyingtianmen big (3).6195c5db.jpg";